(function(){
	'use strict';

	let $scrollBtn = $('.smp-js-scroll-btn'),
	$smpCarousel = $('.smp-carousel');

	if($smpCarousel.length){

		let bannerOffset = null;

		if($smpCarousel.length){
			bannerOffset = ($smpCarousel.offset().top + $smpCarousel.outerHeight()) + 'px';
		}

		$smpCarousel.each(function(){

			let $curCarousel = $(this);

			$(this).find('.smp-carousel__play-btn').click(function(){

				let $cur = $(this);

				if(!$cur.hasClass('active')){
					$cur.addClass('active');
					$curCarousel.carousel('pause');
				}else {
					$cur.removeClass('active');
					$curCarousel.carousel('cycle');
				}

				return false;
			});


		});
	}

}());
